import { Toast } from 'primereact/toast';
import { createContext, useContext, useEffect, useRef, useState } from 'react';

const ToastContext = createContext<Toast | null>(null);

const ToastProvider: React.FC<{
    children?: React.ReactNode;
}> = ({ children }) => {
    const [toast, setToast] = useState<Toast | null>(null);
    const toastRef = useRef<Toast>(null);

    useEffect(() => {
        if (!toastRef.current) return;
        setToast(toastRef.current);
    }, [])

    return (
        <>
            <Toast ref={toastRef} onRemove={() => toastRef.current?.clear()} />
            <ToastContext.Provider value={toast}>
                {children}
            </ToastContext.Provider>
        </>
    );
};

const useToast = () => {
    const context = useContext(ToastContext);
    return context;
};

export { ToastProvider, useToast };
